import { PublicPage } from 'api/website';

type Props = {
  content: PublicPage;
};

export function getContentListingCounts({
  content,
}: Props): Record<string, number> | undefined {
  return content && content.heroSearch && content.heroSearch.listingCounts;
}
